import '../../App.css';
import bg1 from '../../img/bg1.jpg';
import svgunab from '../../img/unab.svg';
import clock from '../../img/hourglass.gif';
import React from 'react';

function Loader() {
  return (
    <section class="style--2">
      <div class="section--bg img--bg">
        <img class="first" src={bg1} alt="" />
      </div>
      <div class="in">
        <header class="marquee">
          <div class="in">
            <div class="maxwidth">
              <div class="logo"></div>
              <div class="ttl gone"></div>
              <div class="air gone"></div>
            </div>
          </div>
        </header>
        <main>
          <div class="maxwidth2 text--center padded--left padded--right">
            <img id="rocket" src={clock} alt="" />
            <div class="ttl big titular">
              <strong>Estamos preparando tu resultado</strong>
            </div>
          </div>
        </main>
      </div>
    </section>
  );
}

export default Loader;
